"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UiStateController_1 = require("../shared/UiStateController");
var UsrAdminsListCtl_1 = require("./components/pages/usr_admins_list/ctl/UsrAdminsListCtl");
var BrandsListCtl_1 = require("./components/pages/main_brands_list/ctl/BrandsListCtl");
var PAdminProfileCtl_1 = require("./components/pages/admin_profile/ctl/PAdminProfileCtl");
var GwsGameProvidersListCtl_1 = require("./components/pages/gws_gameproviders_list/ctl/GwsGameProvidersListCtl");
var UsrPermissionsCtl_1 = require("./components/pages/usr_permissions_list/ctl/UsrPermissionsCtl");
var DashBoardCtl_1 = require("./components/pages/main_dashboard/ctl/DashBoardCtl");
var GwsGameProviderGamesListCtl_1 = require("./components/pages/gws_gameproviders_list/ctl/GwsGameProviderGamesListCtl");
var GameSetsListCtl_1 = require("./components/pages/cms_gamesets_list/ctl/GameSetsListCtl");
var PlayersListCtl_1 = require("./components/pages/main_players_list/ctl/PlayersListCtl");
var GameSetGamesListCtl_1 = require("./components/pages/cms_gamesets_list/ctl/GameSetGamesListCtl");
var CfgCurrencyListCtl_1 = require("./components/pages/cfg_currency/ctl/CfgCurrencyListCtl");
var AffilatesListCtl_1 = require("./components/pages/par_pprograms_list/ctl/AffilatesListCtl");
var BrandsEmailSetTemplateListCtl_1 = require("./components/pages/main_brands_list/ctl/options/BrandsEmailSetTemplateListCtl");
var FinanceDepositsListCtl_1 = require("./components/pages/finance_deposits_list/ctl/FinanceDepositsListCtl");
var FinanceWithdrawsListCtl_1 = require("./components/pages/finance_withdraws_list/ctl/FinanceWithdrawsListCtl");
var BonusTemplatesListCtl_1 = require("./components/pages/gift_bonus_templates/ctl/BonusTemplatesListCtl");
var BonusWagerOnDepositCfgCtl_1 = require("./components/pages/gift_bonus_templates/ctl/wager_on_dep/BonusWagerOnDepositCfgCtl");
var PromoCodeTemplatesListCtl_1 = require("./components/pages/gift_promocodes/ctl/PromoCodeTemplatesListCtl");
var BonusWagerNoDepositCfgCtl_1 = require("./components/pages/gift_bonus_templates/ctl/wager_no_dep/BonusWagerNoDepositCfgCtl");
var PromoCodeTemplateBonusesListCtl_1 = require("./components/pages/gift_promocodes/ctl/PromoCodeTemplateBonusesListCtl");
var PromoCodeTemplateCodesListCtl_1 = require("./components/pages/gift_promocodes/ctl/PromoCodeTemplateCodesListCtl");
var PlayersLevelsListCtl_1 = require("./components/pages/gift_player_levels/ctl/PlayersLevelsListCtl");
var EventBindingsListCtl_1 = require("./components/pages/gift_events_bindings/ctl/EventBindingsListCtl");
var CfgCountryListCtl_1 = require("./components/pages/cfg_country/ctl/CfgCountryListCtl");
var CfgLanguageListCtl_1 = require("./components/pages/cfg_language/ctl/CfgLanguageListCtl");
var coreDialog_1 = require("./coreDialog");
var BrandsPartnersListCtl_1 = require("./components/pages/main_brands_list/ctl/options/BrandsPartnersListCtl");
var BrandGwsGameProviderListCtl_1 = require("./components/pages/main_brands_list/ctl/gateways/BrandGwsGameProviderListCtl");
var PlayerMessagesListCtl_1 = require("./components/pages/main_players_list/ctl/PlayerMessagesListCtl");
var CfgUsrPlayerTagsListCtl_1 = require("./components/pages/cfg_player_tags/ctl/CfgUsrPlayerTagsListCtl");
var PlayerTagsListCtl_1 = require("./components/pages/main_players_list/ctl/PlayerTagsListCtl");
var UsrPermissionDocsCtl_1 = require("./components/pages/usr_permissions_list/ctl/UsrPermissionDocsCtl");
var WinnersTopListCtl_1 = require("./components/pages/cms_winners_top/ctl/WinnersTopListCtl");
var CmsBotsListCtl_1 = require("./components/pages/cms_bots/ctl/CmsBotsListCtl");
var JackpotsListCtl_1 = require("./components/pages/gift_jackpots/ctl/JackpotsListCtl");
var TopGamesListCtl_1 = require("./components/pages/cms_top_games/ctl/TopGamesListCtl");
var PlayerLevelLocalesListCtl_1 = require("./components/pages/gift_player_levels/ctl/PlayerLevelLocalesListCtl");
var PlayerLevelAttributesListCtl_1 = require("./components/pages/gift_player_levels/ctl/PlayerLevelAttributesListCtl");
var PlayerLevelBetAmountsListCtl_1 = require("./components/pages/gift_player_levels/ctl/PlayerLevelBetAmountsListCtl");
var JackpotLocalesListCtl_1 = require("./components/pages/gift_jackpots/ctl/JackpotLocalesListCtl");
var GameSetLocalesListCtl_1 = require("./components/pages/cms_gamesets_list/ctl/GameSetLocalesListCtl");
var DomainListCtl_1 = require("./components/pages/main_domains_list/ctl/DomainListCtl");
var PlayerFavoriteGamesListCtl_1 = require("./components/pages/main_players_list/ctl/PlayerFavoriteGamesListCtl");
var PlayerAuthLogsListCtl_1 = require("./components/pages/main_players_list/ctl/PlayerAuthLogsListCtl");
var CfgClassListCtl_1 = require("./components/pages/cfg_css_class/ctl/CfgClassListCtl");
var BrandsEmailSetTemplateImageListCtl_1 = require("./components/pages/main_brands_list/ctl/options/BrandsEmailSetTemplateImageListCtl");
var GwsGameProviderCfgCtl_1 = require("./components/pages/gws_gameproviders_list/ctl/GwsGameProviderCfgCtl");
var BrandsContentListCtl_1 = require("./components/pages/cms_images/ctl/BrandsContentListCtl");
var CmsPostsCategoryListCtl_1 = require("./components/pages/cms_posts/ctl/CmsPostsCategoryListCtl");
var CmsPostsRecordsListCtl_1 = require("./components/pages/cms_posts/ctl/CmsPostsRecordsListCtl");
var BrandsCurrencyListCtl_1 = require("./components/pages/main_brands_list/ctl/options/BrandsCurrencyListCtl");
var BrandsLanguagesListCtl_1 = require("./components/pages/main_brands_list/ctl/options/BrandsLanguagesListCtl");
var CmsBannersRouteImagesListCtl_1 = require("./components/pages/cms_banners/ctl/CmsBannersRouteImagesListCtl");
var CmsBannersRouteListCtl_1 = require("./components/pages/cms_banners/ctl/CmsBannersRouteListCtl");
var CmsPagesRecordsListCtl_1 = require("./components/pages/cms_pages/ctl/CmsPagesRecordsListCtl");
var CmsPagesDataListCtl_1 = require("./components/pages/cms_pages/ctl/CmsPagesDataListCtl");
var BonusTemplateLocalesListCtl_1 = require("./components/pages/gift_bonus_templates/ctl/BonusTemplateLocalesListCtl");
var ParBrandsBannersListCtl_1 = require("./components/pages/par_brands_banners_list/ctl/ParBrandsBannersListCtl");
var ParBrandsBannersCountriesListCtl_1 = require("./components/pages/par_brands_banners_list/ctl/ParBrandsBannersCountriesListCtl");
var ParBrandsBrandingsListCtl_1 = require("./components/pages/par_brands_brandings_list/ctl/ParBrandsBrandingsListCtl");
var ParBrandsBrandingsCountriesListCtl_1 = require("./components/pages/par_brands_brandings_list/ctl/ParBrandsBrandingsCountriesListCtl");
var ParBrandsLandingsCountriesListCtl_1 = require("./components/pages/par_brands_landings_list/ctl/ParBrandsLandingsCountriesListCtl");
var ParBrandsLandingsListCtl_1 = require("./components/pages/par_brands_landings_list/ctl/ParBrandsLandingsListCtl");
var ParBrandsOffersListCtl_1 = require("./components/pages/par_brands_offers_list/ctl/ParBrandsOffersListCtl");
var ParBrandsOffersLocalesListCtl_1 = require("./components/pages/par_brands_offers_list/ctl/ParBrandsOffersLocalesListCtl");
var AffilatesLanguagesListCtl_1 = require("./components/pages/par_pprograms_list/ctl/options/AffilatesLanguagesListCtl");
var AffilatesCurrencyListCtl_1 = require("./components/pages/par_pprograms_list/ctl/options/AffilatesCurrencyListCtl");
var AffilatesOffersListCtl_1 = require("./components/pages/par_pprograms_list/ctl/options/AffilatesOffersListCtl");
var AffilatesBrandsListCtl_1 = require("./components/pages/par_pprograms_list/ctl/options/AffilatesBrandsListCtl");
var PartnersListCtl_1 = require("./components/pages/par_partners_list/ctl/PartnersListCtl");
var PartnersOffersListCtl_1 = require("./components/pages/par_partners_list/ctl/PartnersOffersListCtl");
var PartnersTrackersListCtl_1 = require("./components/pages/par_partners_list/ctl/PartnersTrackersListCtl");
var FinanceWithdrawRequestsListCtl_1 = require("./components/pages/finance_withdraw_requests_list/ctl/FinanceWithdrawRequestsListCtl");
var PlayerGameLogsListCtl_1 = require("./components/pages/main_players_list/ctl/PlayerGameLogsListCtl");
var JackpotRestrictedPlayerTagsListCtl_1 = require("./components/pages/gift_jackpots/ctl/JackpotRestrictedPlayerTagsListCtl");
var JackpotWinHistoryListCtl_1 = require("./components/pages/gift_jackpots/ctl/JackpotWinHistoryListCtl");
var BrandSmtpCfgCtl_1 = require("./components/pages/main_brands_list/ctl/BrandSmtpCfgCtl");
var PlayerBonusesListCtl_1 = require("./components/pages/main_players_list/ctl/PlayerBonusesListCtl");
var PlayerBonusWagerNoDepositCfgCtl_1 = require("./components/pages/main_players_list/ctl/bonuses/wager_no_dep/PlayerBonusWagerNoDepositCfgCtl");
var PlayerBonusWagerOnDepositCfgCtl_1 = require("./components/pages/main_players_list/ctl/bonuses/wager_on_dep/PlayerBonusWagerOnDepositCfgCtl");
var PlayerPromocodesListCtl_1 = require("./components/pages/main_players_list/ctl/PlayerPromocodesListCtl");
var PromoCodeTemplateCodesLogsListCtl_1 = require("./components/pages/gift_promocodes/ctl/PromoCodeTemplateCodesLogsListCtl");
var BonusTemplatePlayerTagsListCtl_1 = require("./components/pages/gift_bonus_templates/ctl/BonusTemplatePlayerTagsListCtl");
var JackpotTransferHistoryListCtl_1 = require("./components/pages/gift_jackpots/ctl/JackpotTransferHistoryListCtl");
var PlayerJackpotWinsListCtl_1 = require("./components/pages/main_players_list/ctl/PlayerJackpotWinsListCtl");
var EventBindingBonusesListCtl_1 = require("./components/pages/gift_events_bindings/ctl/EventBindingBonusesListCtl");
var EventBindingOnDepositCfgCtl_1 = require("./components/pages/gift_events_bindings/ctl/event_config/config_on_deposit/EventBindingOnDepositCfgCtl");
var EventBindingOnLevelCfgCtl_1 = require("./components/pages/gift_events_bindings/ctl/event_config/config_on_level/EventBindingOnLevelCfgCtl");
var EventBindingOnCashBackCfgCtl_1 = require("./components/pages/gift_events_bindings/ctl/event_config/config_on_cashback/EventBindingOnCashBackCfgCtl");
var BonusWagerCashBackCfgCtl_1 = require("./components/pages/gift_bonus_templates/ctl/wager_cashback/BonusWagerCashBackCfgCtl");
var PlayerBonusWagerCashBackCfgCtl_1 = require("./components/pages/main_players_list/ctl/bonuses/wager_cashback/PlayerBonusWagerCashBackCfgCtl");
var EventBindingDescriptionsListCtl_1 = require("./components/pages/gift_events_bindings/ctl/EventBindingDescriptionsListCtl");
var PlayerLevelOffersListCtl_1 = require("./components/pages/gift_player_levels/ctl/PlayerLevelOffersListCtl");
var CfgPayoutListCtl_1 = require("./components/pages/cfg_payout/ctl/CfgPayoutListCtl");
var BrandsCountryListCtl_1 = require("./components/pages/main_brands_list/ctl/options/BrandsCountryListCtl");
var BrandsPayoutsListCtl_1 = require("./components/pages/main_brands_list/ctl/options/BrandsPayoutsListCtl");
var AffilateSmtpCfgCtl_1 = require("./components/pages/par_pprograms_list/ctl/AffilateSmtpCfgCtl");
var AffilatesCountryListCtl_1 = require("./components/pages/par_pprograms_list/ctl/options/AffilatesCountryListCtl");
var AffilatesPayoutsListCtl_1 = require("./components/pages/par_pprograms_list/ctl/options/AffilatesPayoutsListCtl");
var BrandsLocalesListCtl_1 = require("./components/pages/main_brands_list/ctl/locales/BrandsLocalesListCtl");
var ParBrandsLandingsLocalesListCtl_1 = require("./components/pages/par_brands_landings_list/ctl/ParBrandsLandingsLocalesListCtl");
var ParBrandOffersCountriesListCtl_1 = require("./components/pages/par_brands_offers_list/ctl/ParBrandOffersCountriesListCtl");
var PartnersPayDetailsListCtl_1 = require("./components/pages/par_partners_list/ctl/PartnersPayDetailsListCtl");
var PartnersBalancesListCtl_1 = require("./components/pages/par_partners_list/ctl/PartnersBalancesListCtl");
var PartnersMessagesListCtl_1 = require("./components/pages/par_partners_list/ctl/PartnersMessagesListCtl");
var PromoCodeTemplatesLocalesListCtl_1 = require("./components/pages/gift_promocodes/ctl/locales/PromoCodeTemplatesLocalesListCtl");
var AffilatesPromoCodeTemplatesListCtl_1 = require("./components/pages/par_pprograms_list/ctl/options/AffilatesPromoCodeTemplatesListCtl");
var PartnersPromoCodeTemplatesListCtl_1 = require("./components/pages/par_partners_list/ctl/PartnersPromoCodeTemplatesListCtl");
var PartnerAuthLogsListCtl_1 = require("./components/pages/par_partners_list/ctl/PartnerAuthLogsListCtl");
var FinanceRevsharesListCtl_1 = require("./components/pages/finance_revshares_list/ctl/FinanceRevsharesListCtl");
var PartnersContentListCtl_1 = require("./components/pages/par_images/ctl/PartnersContentListCtl");
var ParNewsListCtl_1 = require("./components/pages/par_news/ctl/ParNewsListCtl");
var ParNewsLocalesListCtl_1 = require("./components/pages/par_news/ctl/ParNewsLocalesListCtl");
var AffilatesEmailSetTemplateImageListCtl_1 = require("./components/pages/par_pprograms_list/ctl/options/AffilatesEmailSetTemplateImageListCtl");
var AffilatesEmailSetTemplateListCtl_1 = require("./components/pages/par_pprograms_list/ctl/options/AffilatesEmailSetTemplateListCtl");
var CfgCountryLocalesListCtl_1 = require("./components/pages/cfg_country/ctl/CfgCountryLocalesListCtl");
var PromoCodeTemplatesCountriesListCtl_1 = require("./components/pages/gift_promocodes/ctl/countries/PromoCodeTemplatesCountriesListCtl");
var BonusTemplateCurrencyConfigListCtl_1 = require("./components/pages/gift_bonus_templates/ctl/BonusTemplateCurrencyConfigListCtl");
var RepTotalProfitCtl_1 = require("./components/pages/rep_total_profit/ctl/RepTotalProfitCtl");
var BonusFreeSpinRangesListCtl_1 = require("./components/pages/gift_fsranges/ctl/BonusFreeSpinRangesListCtl");
var BonusFreeSpinRangeGameSetsListCtl_1 = require("./components/pages/gift_fsranges/ctl/BonusFreeSpinRangeGameSetsListCtl");
var PromoCodeTemplateAmountsListCtl_1 = require("./components/pages/gift_promocodes/ctl/PromoCodeTemplateAmountsListCtl");
var BonusTournamentsListCtl_1 = require("./components/pages/gift_tournament/ctl/BonusTournamentsListCtl");
var BonusTournamentsAmountsListCtl_1 = require("./components/pages/gift_tournament/ctl/options/BonusTournamentsAmountsListCtl");
var BonusTournamentsTicketsListCtl_1 = require("./components/pages/gift_tournament/ctl/options/BonusTournamentsTicketsListCtl");
var BonusTournamentsGamesListCtl_1 = require("./components/pages/gift_tournament/ctl/options/BonusTournamentsGamesListCtl");
var BonusTournamentsPrizesListCtl_1 = require("./components/pages/gift_tournament/ctl/options/BonusTournamentsPrizesListCtl");
var BonusTournamentsLocalesListCtl_1 = require("./components/pages/gift_tournament/ctl/options/BonusTournamentsLocalesListCtl");
var BonusTournamentsBotsListCtl_1 = require("./components/pages/gift_tournament/ctl/options/BonusTournamentsBotsListCtl");
var BonusTournamentsSessionsLictCtl_1 = require("./components/pages/gift_tournament/ctl/options/BonusTournamentsSessionsLictCtl");
var GameSetGamesBotWinsListCtl_1 = require("./components/pages/cms_gamesets_list/ctl/GameSetGamesBotWinsListCtl");
var GwsGameProviderZonesListCtl_1 = require("./components/pages/gws_gameproviders_list/ctl/GwsGameProviderZonesListCtl");
var PlayerTournamentsLictCtl_1 = require("./components/pages/main_players_list/ctl/PlayerTournamentsLictCtl");
var RepBonusesCtl_1 = require("./components/pages/rep_bonuses/ctl/RepBonusesCtl");
var RepPromoCodesCtl_1 = require("./components/pages/rep_promocodes/ctl/RepPromoCodesCtl");
var GameSetFreeSpinBetTargetsListCtl_1 = require("./components/pages/cms_gamesets_list/ctl/GameSetFreeSpinBetTargetsListCtl");
var SupportPromoDetailListCtl_1 = require("./components/pages/support_promo_detail/ctl/SupportPromoDetailListCtl");
var SupportPlayerDetailListCtl_1 = require("./components/pages/support_player_detail/ctl/SupportPlayerDetailListCtl");
var RepPlayerProfitCtl_1 = require("./components/pages/rep_players/ctl/RepPlayerProfitCtl");
var PlayerStatisticsDetailsCtl_1 = require("./components/pages/main_players_list/ctl/PlayerStatisticsDetailsCtl");
var BrandsSmsSetTemplateListCtl_1 = require("./components/pages/main_brands_list/ctl/options/BrandsSmsSetTemplateListCtl");
var BrandSmsCfgCtl_1 = require("./components/pages/main_brands_list/ctl/BrandSmsCfgCtl");
var RepPaySystemsCtl_1 = require("./components/pages/rep_paysystems/ctl/RepPaySystemsCtl");
var EventBindingOnLoginCfgCtl_1 = require("./components/pages/gift_events_bindings/ctl/event_config/config_on_login/EventBindingOnLoginCfgCtl");
var FireWallRulesListCtl_1 = require("./components/pages/security_firewall/ctl/FireWallRulesListCtl");
var PlayerMultiaccountsListCtl_1 = require("./components/pages/main_players_list/ctl/PlayerMultiaccountsListCtl");
var BonusTemplateCfgZonesListCtl_1 = require("./components/pages/gift_bonus_templates/ctl/BonusTemplateCfgZonesListCtl");
var BrandGwsGameProviderSegmentationListCtl_1 = require("./components/pages/main_brands_list/ctl/gateways/BrandGwsGameProviderSegmentationListCtl");
var PlayerSmsLogsListCtl_1 = require("./components/pages/main_players_list/ctl/PlayerSmsLogsListCtl");
var BrandsSmsCfgRestrictionsListCtl_1 = require("./components/pages/main_brands_list/ctl/BrandsSmsCfgRestrictionsListCtl");
var BrandsPayProvidersLictCtl_1 = require("./components/pages/main_brands_list/ctl/options/BrandsPayProvidersLictCtl");
var BrandsAutoWithdrawsListCtl_1 = require("./components/pages/main_brands_list/ctl/options/BrandsAutoWithdrawsListCtl");
var PlayerBonusEventsLogsListCtl_1 = require("./components/pages/main_players_list/ctl/PlayerBonusEventsLogsListCtl");
var FinanceReconciliationsListCtl_1 = require("./components/pages/finance_reconciliations/ctl/FinanceReconciliationsListCtl");
var FinanceReconciliationPartnersListCtl_1 = require("./components/pages/finance_reconciliations/ctl/FinanceReconciliationPartnersListCtl");
var BonusTournamentsMinBetsLictCtl_1 = require("./components/pages/gift_tournament/ctl/options/BonusTournamentsMinBetsLictCtl");
var PlayerWhiteIpListCtl_1 = require("./components/pages/main_players_list/ctl/PlayerWhiteIpListCtl");
var BrandsBlackIpListCtl_1 = require("./components/pages/main_brands_list/ctl/options/BrandsBlackIpListCtl");
var BrandsPayoutsKeyValsListCtl_1 = require("./components/pages/main_brands_list/ctl/options/BrandsPayoutsKeyValsListCtl");
var RepWithdrawalsCtl_1 = require("./components/pages/rep_withdrawals/ctl/RepWithdrawalsCtl");
var TrustHandlersListCtl_1 = require("./components/pages/security_trust_handlers/ctl/TrustHandlersListCtl");
var BrandsMessageSetTemplateListCtl_1 = require("./components/pages/main_brands_list/ctl/options/BrandsMessageSetTemplateListCtl");
var AppPaySystemsListCtl_1 = require("./components/pages/app_paysystem/ctl/AppPaySystemsListCtl");
var AppPsySystemWalletsListCtl_1 = require("./components/pages/app_paysystem_wallets/ctl/AppPsySystemWalletsListCtl");
var AppPsySystemTransactionsListCtl_1 = require("./components/pages/app_paysystem_transactions/ctl/AppPsySystemTransactionsListCtl");
var AppPaySystemsPayWaysListCtl_1 = require("./components/pages/app_paysystem/ctl/AppPaySystemsPayWaysListCtl");
var AppPaySystemWalletsLocksListCtl_1 = require("./components/pages/app_paysystem_wallets/ctl/AppPaySystemWalletsLocksListCtl");
var AppPaySystemWalletsReceivesListCtl_1 = require("./components/pages/app_paysystem_wallets/ctl/AppPaySystemWalletsReceivesListCtl");
var AppCapchaTemplatesListCtl_1 = require("./components/pages/app_capcha/ctl/AppCapchaTemplatesListCtl");
var CfgTrustZonesListCtl_1 = require("./components/pages/cfg_trust_zones/ctl/CfgTrustZonesListCtl");
var BrandsPayProvidersByTrustZonesCtl_1 = require("./components/pages/main_brands_list/ctl/options/BrandsPayProvidersByTrustZonesCtl");
var PersonalPromoCodesListCtl_1 = require("./components/pages/gift_personal/ctl/PersonalPromoCodesListCtl");
var PersonalPromoCodesHistoryListCtl_1 = require("./components/pages/gift_personal/ctl/PersonalPromoCodesHistoryListCtl");
var SPlayerPersonalPromoCodesListCtl_1 = require("./components/pages/support_player_personal_promocodes/ctl/SPlayerPersonalPromoCodesListCtl");
//import { ReportPaySystemsListCtl } from "./components/pages/rep_paysystems/ctl/RepPaySYstemsCtl";
var ADMIN = /** @class */ (function () {
    function ADMIN() {
    }
    Object.defineProperty(ADMIN, "UIState", {
        /* ----------------STATE------------------------  */
        get: function () {
            if (!this._UIState) {
                this._UIState = new UiStateController_1.UIStateController(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._UIState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "SPlayerPersonalPromoCodesList", {
        get: function () {
            if (!this._SPlayerPersonalPromoCodesList) {
                this._SPlayerPersonalPromoCodesList = new SPlayerPersonalPromoCodesListCtl_1.SPlayerPersonalPromoCodesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._SPlayerPersonalPromoCodesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PersonalPromoCodesHistoryList", {
        get: function () {
            if (!this._PersonalPromoCodesHistoryList) {
                this._PersonalPromoCodesHistoryList = new PersonalPromoCodesHistoryListCtl_1.PersonalPromoCodesHistoryListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PersonalPromoCodesHistoryList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PersonalPromoCodesList", {
        get: function () {
            if (!this._PersonalPromoCodesList) {
                this._PersonalPromoCodesList = new PersonalPromoCodesListCtl_1.PersonalPromoCodesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PersonalPromoCodesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BrandsPayProvidersByTrustZonesList", {
        get: function () {
            if (!this._BrandsPayProvidersByTrustZonesList) {
                this._BrandsPayProvidersByTrustZonesList = new BrandsPayProvidersByTrustZonesCtl_1.BrandsPayProvidersByTrustZonesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BrandsPayProvidersByTrustZonesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "CfgTrustZonesList", {
        get: function () {
            if (!this._CfgTrustZonesList) {
                this._CfgTrustZonesList = new CfgTrustZonesListCtl_1.CfgTrustZonesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._CfgTrustZonesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "AppCapchaTemplatesList", {
        get: function () {
            if (!this._AppCapchaTemplatesList) {
                this._AppCapchaTemplatesList = new AppCapchaTemplatesListCtl_1.AppCapchaTemplatesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._AppCapchaTemplatesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "AppPaySystemWalletsReceivesList", {
        get: function () {
            if (!this._AppPaySystemWalletsReceivesList) {
                this._AppPaySystemWalletsReceivesList = new AppPaySystemWalletsReceivesListCtl_1.AppPaySystemWalletsReceivesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._AppPaySystemWalletsReceivesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "AppPaySystemWalletsLocksList", {
        get: function () {
            if (!this._AppPaySystemWalletsLocksList) {
                this._AppPaySystemWalletsLocksList = new AppPaySystemWalletsLocksListCtl_1.AppPaySystemWalletsLocksListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._AppPaySystemWalletsLocksList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "AppPaySystemsPayWaysList", {
        get: function () {
            if (!this._AppPaySystemsPayWaysList) {
                this._AppPaySystemsPayWaysList = new AppPaySystemsPayWaysListCtl_1.AppPaySystemsPayWaysListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._AppPaySystemsPayWaysList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "AppPsySystemTransactionsList", {
        get: function () {
            if (!this._AppPsySystemTransactionsList) {
                this._AppPsySystemTransactionsList = new AppPsySystemTransactionsListCtl_1.AppPsySystemTransactionsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._AppPsySystemTransactionsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "AppPaySystemWalletsList", {
        get: function () {
            if (!this._AppPaySystemWalletsList) {
                this._AppPaySystemWalletsList = new AppPsySystemWalletsListCtl_1.AppPaySystemWalletsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._AppPaySystemWalletsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "AppPaySystemsList", {
        get: function () {
            if (!this._AppPaySystemsList) {
                this._AppPaySystemsList = new AppPaySystemsListCtl_1.AppPaySystemsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._AppPaySystemsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BrandsMessageSetTemplatesList", {
        get: function () {
            if (!this._BrandsMessageSetTemplatesList) {
                this._BrandsMessageSetTemplatesList = new BrandsMessageSetTemplateListCtl_1.BrandsMessageSetTemplatesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BrandsMessageSetTemplatesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "TrustEventHandlersList", {
        get: function () {
            if (!this._TrustEventHandlersList) {
                this._TrustEventHandlersList = new TrustHandlersListCtl_1.TrustEventHandlersListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._TrustEventHandlersList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PlayersWhiteIpList", {
        get: function () {
            if (!this._PlayersWhiteIpList) {
                this._PlayersWhiteIpList = new PlayerWhiteIpListCtl_1.PlayersWhiteIpListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PlayersWhiteIpList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BrandsBlackIpList", {
        get: function () {
            if (!this._BrandsBlackIpList) {
                this._BrandsBlackIpList = new BrandsBlackIpListCtl_1.BrandsBlackIpListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BrandsBlackIpList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BonusTournamentsMinBetsList", {
        get: function () {
            if (!this._BonusTournamentsMinBetsList) {
                this._BonusTournamentsMinBetsList = new BonusTournamentsMinBetsLictCtl_1.BonusTournamentsMinBetsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BonusTournamentsMinBetsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "FinanceReconciliationPartnersList", {
        get: function () {
            if (!this._FinanceReconciliationPartnersList) {
                this._FinanceReconciliationPartnersList = new FinanceReconciliationPartnersListCtl_1.FinanceReconciliationPartnersListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._FinanceReconciliationPartnersList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "FinanceReconciliationsList", {
        get: function () {
            if (!this._FinanceReconciliationsList) {
                this._FinanceReconciliationsList = new FinanceReconciliationsListCtl_1.FinanceReconciliationsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._FinanceReconciliationsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PlayerBonusEventsLogsList", {
        get: function () {
            if (!this._PlayerBonusEventsLogsList) {
                this._PlayerBonusEventsLogsList = new PlayerBonusEventsLogsListCtl_1.PlayerBonusEventsLogsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PlayerBonusEventsLogsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BrandsAutoWithdrawsList", {
        get: function () {
            if (!this._BrandsAutoWithdrawsList) {
                this._BrandsAutoWithdrawsList = new BrandsAutoWithdrawsListCtl_1.BrandsAutoWithdrawsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BrandsAutoWithdrawsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BrandsPayProvidersList", {
        //private static _FireWallRulesList : FireWallRulesListCtl;
        //private static _PlayerSmsLogList : PlayerSmsLogListCtl;
        //private static _BrandsSmsCfgRestrictionsList : BrandsSmsCfgRestrictionsListCtl;
        get: function () {
            if (!this._BrandsPayProvidersList) {
                this._BrandsPayProvidersList = new BrandsPayProvidersLictCtl_1.BrandsPayProvidersListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BrandsPayProvidersList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BrandsSmsCfgRestrictionsList", {
        get: function () {
            if (!this._BrandsSmsCfgRestrictionsList) {
                this._BrandsSmsCfgRestrictionsList = new BrandsSmsCfgRestrictionsListCtl_1.BrandsSmsCfgRestrictionsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BrandsSmsCfgRestrictionsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PlayerSmsLogList", {
        get: function () {
            if (!this._PlayerSmsLogList) {
                this._PlayerSmsLogList = new PlayerSmsLogsListCtl_1.PlayerSmsLogListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PlayerSmsLogList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BrandGwsGameProviderSegmentationList", {
        //private static _BrandGwsGameProviderSegmentationList : BrandGwsGameProviderSegmentationListCtl;
        get: function () {
            if (!this._BrandGwsGameProviderSegmentationList) {
                this._BrandGwsGameProviderSegmentationList = new BrandGwsGameProviderSegmentationListCtl_1.BrandGwsGameProviderSegmentationListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BrandGwsGameProviderSegmentationList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BonusTemplateCfgZonesList", {
        //private static _BonusTemplateCfgZonesList : BonusTemplateCfgZonesListCtl;
        get: function () {
            if (!this._BonusTemplateCfgZonesList) {
                this._BonusTemplateCfgZonesList = new BonusTemplateCfgZonesListCtl_1.BonusTemplateCfgZonesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BonusTemplateCfgZonesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "FireWallRulesList", {
        get: function () {
            if (!this._FireWallRulesList) {
                this._FireWallRulesList = new FireWallRulesListCtl_1.FireWallRulesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._FireWallRulesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "SupportPlayerDetailList", {
        get: function () {
            if (!this._SupportPlayerDetailList) {
                this._SupportPlayerDetailList = new SupportPlayerDetailListCtl_1.SupportPlayerDetailListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._SupportPlayerDetailList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "SupportPromoDetailList", {
        get: function () {
            if (!this._SupportPromoDetailList) {
                this._SupportPromoDetailList = new SupportPromoDetailListCtl_1.SupportPromoDetailListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._SupportPromoDetailList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "GameSetFreeSpinBetTargetsList", {
        get: function () {
            if (!this._GameSetFreeSpinBetTargetsList) {
                this._GameSetFreeSpinBetTargetsList = new GameSetFreeSpinBetTargetsListCtl_1.GameSetFreeSpinBetTargetsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._GameSetFreeSpinBetTargetsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PlayerTournamentsList", {
        get: function () {
            if (!this._PlayerTournamentsList) {
                this._PlayerTournamentsList = new PlayerTournamentsLictCtl_1.PlayerTournamentsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PlayerTournamentsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "GwsGameProvidersZonesList", {
        get: function () {
            if (!this._GwsGameProvidersZonesList) {
                this._GwsGameProvidersZonesList = new GwsGameProviderZonesListCtl_1.GwsGameProvidersZonesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._GwsGameProvidersZonesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BonusTournamentsList", {
        get: function () {
            if (!this._BonusTournamentsList) {
                this._BonusTournamentsList = new BonusTournamentsListCtl_1.BonusTournamentsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BonusTournamentsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BonusTournamentsSessionsList", {
        get: function () {
            if (!this._BonusTournamentsSessionsList) {
                this._BonusTournamentsSessionsList = new BonusTournamentsSessionsLictCtl_1.BonusTournamentsSessionsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BonusTournamentsSessionsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BonusTournamentsAmountsList", {
        get: function () {
            if (!this._BonusTournamentsAmountsList) {
                this._BonusTournamentsAmountsList = new BonusTournamentsAmountsListCtl_1.BonusTournamentsAmountsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BonusTournamentsAmountsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BonusTournamentsTicketsList", {
        get: function () {
            if (!this._BonusTournamentsTicketsList) {
                this._BonusTournamentsTicketsList = new BonusTournamentsTicketsListCtl_1.BonusTournamentsTicketsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BonusTournamentsTicketsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BonusTournamentsGamesList", {
        get: function () {
            if (!this._BonusTournamentsGamesList) {
                this._BonusTournamentsGamesList = new BonusTournamentsGamesListCtl_1.BonusTournamentsGamesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BonusTournamentsGamesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BonusTournamentsPrizesList", {
        get: function () {
            if (!this._BonusTournamentsPrizesList) {
                this._BonusTournamentsPrizesList = new BonusTournamentsPrizesListCtl_1.BonusTournamentsPrizesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BonusTournamentsPrizesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BonusTournamentLocalesList", {
        get: function () {
            if (!this._BonusTournamentLocalesList) {
                this._BonusTournamentLocalesList = new BonusTournamentsLocalesListCtl_1.BonusTournamentLocalesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BonusTournamentLocalesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BonusTournamentsBotsList", {
        get: function () {
            if (!this._BonusTournamentsBotsList) {
                this._BonusTournamentsBotsList = new BonusTournamentsBotsListCtl_1.BonusTournamentsBotsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BonusTournamentsBotsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BonusFreespinRangesList", {
        get: function () {
            if (!this._BonusFreespinRangesList) {
                this._BonusFreespinRangesList = new BonusFreeSpinRangesListCtl_1.BonusFreespinRangesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BonusFreespinRangesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BonusFreespinRangeGameSetsList", {
        get: function () {
            if (!this._BonusFreespinRangeGameSetsList) {
                this._BonusFreespinRangeGameSetsList = new BonusFreeSpinRangeGameSetsListCtl_1.BonusFreespinRangeGameSetsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BonusFreespinRangeGameSetsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PartnersNewsList", {
        /* --------------------PARTNERS-------------------- */
        get: function () {
            if (!this._ParNewsList) {
                this._ParNewsList = new ParNewsListCtl_1.ParNewsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ParNewsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PartnersLocalesNewsList", {
        get: function () {
            if (!this._ParNewsLocalesList) {
                this._ParNewsLocalesList = new ParNewsLocalesListCtl_1.ParNewsLocalesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ParNewsLocalesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PartnersPromoCodeTemplatesList", {
        //private static _PartnersPromoCodeTemplatesList : PartnersPromoCodeTemplatesListCtl;
        get: function () {
            if (!this._PartnersPromoCodeTemplatesList) {
                this._PartnersPromoCodeTemplatesList = new PartnersPromoCodeTemplatesListCtl_1.PartnersPromoCodeTemplatesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PartnersPromoCodeTemplatesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PartnerAuthLogList", {
        //private static _PartnerAuthLogList : PartnerAuthLogListCtl;
        get: function () {
            if (!this._PartnerAuthLogList) {
                this._PartnerAuthLogList = new PartnerAuthLogsListCtl_1.PartnerAuthLogListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PartnerAuthLogList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PProgramsContentList", {
        //private static _PProgramsContentList : PProgramsContentListCtl;
        get: function () {
            if (!this._PProgramsContentList) {
                this._PProgramsContentList = new PartnersContentListCtl_1.PProgramsContentListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PProgramsContentList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PartnersMessagesList", {
        get: function () {
            if (!this._PartnersMessagesList) {
                this._PartnersMessagesList = new PartnersMessagesListCtl_1.PartnersMessagesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PartnersMessagesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PartnersBalancesList", {
        get: function () {
            if (!this._PartnersBalancesList) {
                this._PartnersBalancesList = new PartnersBalancesListCtl_1.PartnersBalancesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PartnersBalancesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PartnersPayDetailsList", {
        get: function () {
            if (!this._PartnersPayDetailsList) {
                this._PartnersPayDetailsList = new PartnersPayDetailsListCtl_1.PartnersPayDetailsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PartnersPayDetailsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PartnersTrackersList", {
        get: function () {
            if (!this._PartnersTrackersList) {
                this._PartnersTrackersList = new PartnersTrackersListCtl_1.PartnersTrackersListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PartnersTrackersList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PartnersOffersList", {
        get: function () {
            if (!this._PartnersOffersList) {
                this._PartnersOffersList = new PartnersOffersListCtl_1.PartnersOffersListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PartnersOffersList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PartnersList", {
        get: function () {
            if (!this._PartnersList) {
                this._PartnersList = new PartnersListCtl_1.PartnersListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PartnersList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "ParBrandsOffersList", {
        get: function () {
            if (!this._ParBrandsOffersList) {
                this._ParBrandsOffersList = new ParBrandsOffersListCtl_1.ParBrandsOffersListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ParBrandsOffersList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "ParBrandsOffersLocalesList", {
        get: function () {
            if (!this._ParBrandsOffersLocalesList) {
                this._ParBrandsOffersLocalesList = new ParBrandsOffersLocalesListCtl_1.ParBrandsOffersLocalesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ParBrandsOffersLocalesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "ParBrandsLandingsList", {
        get: function () {
            if (!this._ParBrandsLandingsList) {
                this._ParBrandsLandingsList = new ParBrandsLandingsListCtl_1.ParBrandsLandingsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ParBrandsLandingsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "ParBrandsLandingsCountriesList", {
        get: function () {
            if (!this._ParBrandsLandingsCountriesList) {
                this._ParBrandsLandingsCountriesList = new ParBrandsLandingsCountriesListCtl_1.ParBrandsLandingsCountriesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ParBrandsLandingsCountriesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "ParBrandsBrandingsList", {
        get: function () {
            if (!this._ParBrandsBrandingsList) {
                this._ParBrandsBrandingsList = new ParBrandsBrandingsListCtl_1.ParBrandsBrandingsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ParBrandsBrandingsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "ParBrandsLandingsLocalesList", {
        get: function () {
            if (!this._ParBrandsLandingsLocalesList) {
                this._ParBrandsLandingsLocalesList = new ParBrandsLandingsLocalesListCtl_1.ParBrandsLandingsLocalesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ParBrandsLandingsLocalesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "ParBrandsBrandingsCountriesList", {
        get: function () {
            if (!this._ParBrandsBrandingsCountriesList) {
                this._ParBrandsBrandingsCountriesList = new ParBrandsBrandingsCountriesListCtl_1.ParBrandsBrandingsCountriesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ParBrandsBrandingsCountriesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "ParBrandsBannersList", {
        get: function () {
            if (!this._ParBrandsBannersList) {
                this._ParBrandsBannersList = new ParBrandsBannersListCtl_1.ParBrandsBannersListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ParBrandsBannersList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "ParBrandsBannersCountriesList", {
        get: function () {
            if (!this._ParBrandsBannersCountriesList) {
                this._ParBrandsBannersCountriesList = new ParBrandsBannersCountriesListCtl_1.ParBrandsBannersCountriesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ParBrandsBannersCountriesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "AffilatesBrandsList", {
        get: function () {
            if (!this._AffilatesBrandsList) {
                this._AffilatesBrandsList = new AffilatesBrandsListCtl_1.AffilatesBrandsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._AffilatesBrandsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "AffilatesCountryList", {
        get: function () {
            if (!this._AffilatesCountryList) {
                this._AffilatesCountryList = new AffilatesCountryListCtl_1.AffilatesCountryListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._AffilatesCountryList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "AffilatesPayoutsList", {
        //private static _AffilatesPromoCodeTemplatesList : AffilatesPromoCodeTemplatesListCtl;
        get: function () {
            if (!this._AffilatesPayoutsList) {
                this._AffilatesPayoutsList = new AffilatesPayoutsListCtl_1.AffilatesPayoutsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._AffilatesPayoutsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "AffilatesPromoCodeTemplatesList", {
        get: function () {
            if (!this._AffilatesPromoCodeTemplatesList) {
                this._AffilatesPromoCodeTemplatesList = new AffilatesPromoCodeTemplatesListCtl_1.AffilatesPromoCodeTemplatesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._AffilatesPromoCodeTemplatesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "AffilatesOffersList", {
        get: function () {
            if (!this._AffilatesOffersList) {
                this._AffilatesOffersList = new AffilatesOffersListCtl_1.AffilatesOffersListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._AffilatesOffersList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "AffilatesOffersCountriesList", {
        get: function () {
            if (!this._AffilatesOffersCountriesList) {
                this._AffilatesOffersCountriesList = new ParBrandOffersCountriesListCtl_1.ParBrandsOffersCountriesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._AffilatesOffersCountriesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "AffilatesLanguageList", {
        get: function () {
            if (!this._AffilatesLanguageList) {
                this._AffilatesLanguageList = new AffilatesLanguagesListCtl_1.AffilatesLanguageListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._AffilatesLanguageList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "AffilatesCurrencyList", {
        get: function () {
            if (!this._AffilatesCurrencyList) {
                this._AffilatesCurrencyList = new AffilatesCurrencyListCtl_1.AffilatesCurrencyListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._AffilatesCurrencyList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "AffilatesList", {
        get: function () {
            if (!this._AffilatesList) {
                this._AffilatesList = new AffilatesListCtl_1.AffilatesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._AffilatesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "AffilatesSmtpCfg", {
        get: function () {
            if (!this._AffilateSmtpCfg) {
                this._AffilateSmtpCfg = new AffilateSmtpCfgCtl_1.AffilatesSmtpCfgCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._AffilateSmtpCfg;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "AffilatesEMailSetTemplateList", {
        get: function () {
            if (!this._AffilatesEMailSetTemplateList) {
                this._AffilatesEMailSetTemplateList = new AffilatesEmailSetTemplateListCtl_1.AffilatesEMailSetTemplatesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._AffilatesEMailSetTemplateList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BrandsSmsSetTemplateList", {
        //private static _BrandsSmsSetTemplatesList : BrandsSmsSetTemplatesListCtl;
        get: function () {
            if (!this._BrandsSmsSetTemplatesList) {
                this._BrandsSmsSetTemplatesList = new BrandsSmsSetTemplateListCtl_1.BrandsSmsSetTemplatesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BrandsSmsSetTemplatesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "AffilatesEMailSetTemplateImagesList", {
        get: function () {
            if (!this._AffilatesEMailSetTemplateImagesList) {
                this._AffilatesEMailSetTemplateImagesList = new AffilatesEmailSetTemplateImageListCtl_1.AffilatesEMailSetTemplateImagesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._AffilatesEMailSetTemplateImagesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "CmsBannersRouteList", {
        /* ---------------------BANNERS-------------------- */
        get: function () {
            if (!this._CmsBannersRouteList) {
                this._CmsBannersRouteList = new CmsBannersRouteListCtl_1.CmsBannersRouteListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._CmsBannersRouteList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "CmsBannersRouteImagesList", {
        get: function () {
            if (!this._CmsBannersRouteImagesList) {
                this._CmsBannersRouteImagesList = new CmsBannersRouteImagesListCtl_1.CmsBannersRouteImagesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._CmsBannersRouteImagesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "CmsPagesDataList", {
        /* ---------------------PAGES-------------------- */
        get: function () {
            if (!this._CmsPagesDataList) {
                this._CmsPagesDataList = new CmsPagesDataListCtl_1.CmsPagesDataListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._CmsPagesDataList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "CmsPagesRecordsList", {
        get: function () {
            if (!this._CmsPagesRecordsList) {
                this._CmsPagesRecordsList = new CmsPagesRecordsListCtl_1.CmsPagesRecordsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._CmsPagesRecordsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "CmsPostCategoryList", {
        get: function () {
            if (!this._CmsPostCategoryList) {
                this._CmsPostCategoryList = new CmsPostsCategoryListCtl_1.CmsPostsCategoryListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._CmsPostCategoryList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "CmsPostRecordsList", {
        get: function () {
            if (!this._CmsPostsRecordsList) {
                this._CmsPostsRecordsList = new CmsPostsRecordsListCtl_1.CmsPostsRecordsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._CmsPostsRecordsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "CfgCurrencyList", {
        get: function () {
            if (!this._CfgCurrencyList) {
                this._CfgCurrencyList = new CfgCurrencyListCtl_1.CfgCurrencyListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._CfgCurrencyList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "CfgCountryList", {
        get: function () {
            if (!this._CfgCountryList) {
                this._CfgCountryList = new CfgCountryListCtl_1.CfgCountryListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._CfgCountryList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "CfgCountryLocalesList", {
        get: function () {
            if (!this._CfgCountryLocalesList) {
                this._CfgCountryLocalesList = new CfgCountryLocalesListCtl_1.CfgCountryLocalesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._CfgCountryLocalesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "CfgCssClassList", {
        get: function () {
            if (!this._CfgCssClassesList) {
                this._CfgCssClassesList = new CfgClassListCtl_1.CfgCssClassesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._CfgCssClassesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "CfgPayoutList", {
        get: function () {
            if (!this._CfgPayoutList) {
                this._CfgPayoutList = new CfgPayoutListCtl_1.CfgPayoutListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._CfgPayoutList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "CfgLanguageList", {
        get: function () {
            if (!this._CfgLanguageList) {
                this._CfgLanguageList = new CfgLanguageListCtl_1.CfgLanguageListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._CfgLanguageList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "CfgUsrPlayerTagsList", {
        get: function () {
            if (!this._CfgUsrPlayerTagsList) {
                this._CfgUsrPlayerTagsList = new CfgUsrPlayerTagsListCtl_1.CfgUsrPlayerTagsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._CfgUsrPlayerTagsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BonusWagerOnDepositConfig", {
        /* ----------- BONUSES CONFIG ------------------- */
        get: function () {
            if (!this._BonusWagerOnDepositConfig) {
                this._BonusWagerOnDepositConfig = new BonusWagerOnDepositCfgCtl_1.BonusWagerOnDepositCfgCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BonusWagerOnDepositConfig;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BonusWagerNoDepositConfig", {
        get: function () {
            if (!this._BonusWagerNoDepositConfig) {
                this._BonusWagerNoDepositConfig = new BonusWagerNoDepositCfgCtl_1.BonusWagerNoDepositCfgCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BonusWagerNoDepositConfig;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BonusWagerCashBackConfig", {
        get: function () {
            if (!this._BonusWagerCashBackCfgCtl) {
                this._BonusWagerCashBackCfgCtl = new BonusWagerCashBackCfgCtl_1.BonusWagerCashBackCfgCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BonusWagerCashBackCfgCtl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "GameSets", {
        /* ------------- PAGES -------------------------- */
        get: function () {
            if (!this._GameSetsList) {
                this._GameSetsList = new GameSetsListCtl_1.GameSetsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._GameSetsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "GameSetGamesList", {
        get: function () {
            if (!this._GameSetsGamesList) {
                this._GameSetsGamesList = new GameSetGamesListCtl_1.GameSetsGamesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._GameSetsGamesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "GameSetGamesBotWinsList", {
        //private static _GameSetGamesBotWinsList : GameSetGamesBotWinsListCtl;
        get: function () {
            if (!this._GameSetGamesBotWinsList) {
                this._GameSetGamesBotWinsList = new GameSetGamesBotWinsListCtl_1.GameSetGamesBotWinsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._GameSetGamesBotWinsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "GameSetLocalesList", {
        get: function () {
            if (!this._GameSetLocalesList) {
                this._GameSetLocalesList = new GameSetLocalesListCtl_1.GameSetLocalesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._GameSetLocalesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "CmsBotsList", {
        get: function () {
            if (!this._CmsBotsList) {
                this._CmsBotsList = new CmsBotsListCtl_1.CmsBotsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._CmsBotsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "WinnersTopList", {
        get: function () {
            if (!this._WinnersTopList) {
                this._WinnersTopList = new WinnersTopListCtl_1.WinnersTopListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._WinnersTopList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BrandsContentList", {
        get: function () {
            if (!this._BrandsContentList) {
                this._BrandsContentList = new BrandsContentListCtl_1.BrandsContentListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BrandsContentList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "DashBoard", {
        get: function () {
            if (!this._DashBoard) {
                this._DashBoard = new DashBoardCtl_1.DashBoardCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._DashBoard;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "AdminProfile", {
        get: function () {
            if (!this._PageAdminProfile) {
                this._PageAdminProfile = new PAdminProfileCtl_1.PAdminProfileCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PageAdminProfile;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "GwsGameProvidersList", {
        //----------------BEGIN GATEWAYS-----------------------------------------------
        get: function () {
            if (!this._GwsGameProviderList) {
                this._GwsGameProviderList = new GwsGameProvidersListCtl_1.GwsGameProvidersListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._GwsGameProviderList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "GwsGameProviderB2bCfg", {
        get: function () {
            if (!this._GwsGameProviderConfig) {
                this._GwsGameProviderConfig = new GwsGameProviderCfgCtl_1.GwsGameProviderCfgCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._GwsGameProviderConfig;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BrandsSmtpCfg", {
        get: function () {
            if (!this._BrandsSmtpCfg) {
                this._BrandsSmtpCfg = new BrandSmtpCfgCtl_1.BrandsSmtpCfgCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BrandsSmtpCfg;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BrandsSmsCfg", {
        //private static _BrandsSmsCfg: BrandsSmsCfgCtl;
        get: function () {
            if (!this._BrandsSmsCfg) {
                this._BrandsSmsCfg = new BrandSmsCfgCtl_1.BrandsSmsCfgCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BrandsSmsCfg;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "GwsEMailSetTemplateList", {
        get: function () {
            if (!this._BrandsEMailSetTemplateList) {
                this._BrandsEMailSetTemplateList = new BrandsEmailSetTemplateListCtl_1.BrandsEMailSetTemplatesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BrandsEMailSetTemplateList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "GwsEMailSetTemplateImagesList", {
        get: function () {
            if (!this._BrandsEMailSetTemplateImagesList) {
                this._BrandsEMailSetTemplateImagesList = new BrandsEmailSetTemplateImageListCtl_1.BrandsEMailSetTemplateImagesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BrandsEMailSetTemplateImagesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "GwsGameProviderGamesList", {
        get: function () {
            if (!this._GwsGameProviderGamesList) {
                this._GwsGameProviderGamesList = new GwsGameProviderGamesListCtl_1.GwsGameProvidersGamesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._GwsGameProviderGamesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BrandsList", {
        //----------------END GATEWAYS-------------------------------------------------
        get: function () {
            if (!this._BrandsList) {
                this._BrandsList = new BrandsListCtl_1.BrandsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BrandsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BrandAffilateList", {
        get: function () {
            if (!this._BrandAffilateList) {
                this._BrandAffilateList = new BrandsPartnersListCtl_1.BrandPartnersListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BrandAffilateList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BrandGwsGameProviderList", {
        get: function () {
            if (!this._BrandGwsGameProviderList) {
                this._BrandGwsGameProviderList = new BrandGwsGameProviderListCtl_1.BrandGwsGameProviderListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BrandGwsGameProviderList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BrandCurrencyList", {
        get: function () {
            if (!this._BrandsCurrencyList) {
                this._BrandsCurrencyList = new BrandsCurrencyListCtl_1.BrandsCurrencyListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BrandsCurrencyList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BrandLanguageList", {
        get: function () {
            if (!this._BrandsLanguageList) {
                this._BrandsLanguageList = new BrandsLanguagesListCtl_1.BrandsLanguageListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BrandsLanguageList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BrandCountryList", {
        get: function () {
            if (!this._BrandsCountryList) {
                this._BrandsCountryList = new BrandsCountryListCtl_1.BrandsCountryListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BrandsCountryList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BrandPayoutList", {
        get: function () {
            if (!this._BrandsPayoutList) {
                this._BrandsPayoutList = new BrandsPayoutsListCtl_1.BrandsPayoutListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BrandsPayoutList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BrandPayoutKeyValList", {
        //private static _BrandsPayoutsKeyValsList : BrandsPayoutsKeyValsListCtl;
        get: function () {
            if (!this._BrandsPayoutsKeyValsList) {
                this._BrandsPayoutsKeyValsList = new BrandsPayoutsKeyValsListCtl_1.BrandsPayoutsKeyValsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BrandsPayoutsKeyValsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BrandsLocalesList", {
        get: function () {
            if (!this._BrandsLocalesList) {
                this._BrandsLocalesList = new BrandsLocalesListCtl_1.BrandsLocalesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BrandsLocalesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "UsrAdminsList", {
        get: function () {
            if (!this._UsrAdminsList) {
                this._UsrAdminsList = new UsrAdminsListCtl_1.UsrAdminsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._UsrAdminsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PlayersList", {
        get: function () {
            if (!this._PlayersList) {
                this._PlayersList = new PlayersListCtl_1.PlayersListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PlayersList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PlayerStatisticsDetails", {
        //private static _PlayerStatisticsDetails: PlayerStatisticsDetailsCtl;
        get: function () {
            if (!this._PlayerStatisticsDetails) {
                this._PlayerStatisticsDetails = new PlayerStatisticsDetailsCtl_1.PlayerStatisticsDetailsCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PlayerStatisticsDetails;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PlayerMessagesList", {
        get: function () {
            if (!this._PlayerMessagesList) {
                this._PlayerMessagesList = new PlayerMessagesListCtl_1.PlayersMessagesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PlayerMessagesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PlayerTagsList", {
        get: function () {
            if (!this._PlayerTagsList) {
                this._PlayerTagsList = new PlayerTagsListCtl_1.PlayerTagsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PlayerTagsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PlayerBonusesList", {
        get: function () {
            if (!this._PlayerBonusesList) {
                this._PlayerBonusesList = new PlayerBonusesListCtl_1.PlayerBonusesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PlayerBonusesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PlayerBonusWagerNoDepCfg", {
        get: function () {
            if (!this._PlayerBonusWagerNoDepCfg) {
                this._PlayerBonusWagerNoDepCfg = new PlayerBonusWagerNoDepositCfgCtl_1.PlayerBonusWagerNoDepositCfgCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PlayerBonusWagerNoDepCfg;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PlayerBonusWagerOnDepCfg", {
        get: function () {
            if (!this._PlayerBonusWagerOnDepCfg) {
                this._PlayerBonusWagerOnDepCfg = new PlayerBonusWagerOnDepositCfgCtl_1.PlayerBonusWagerOnDepositCfgCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PlayerBonusWagerOnDepCfg;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PlayerBonusWagerCashBackCfg", {
        get: function () {
            if (!this._PlayerBonusWagerCashBackCfg) {
                this._PlayerBonusWagerCashBackCfg = new PlayerBonusWagerCashBackCfgCtl_1.PlayerBonusWagerCashBackCfgCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PlayerBonusWagerCashBackCfg;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PlayerPromocodesList", {
        get: function () {
            if (!this._PlayerPromocodesList) {
                this._PlayerPromocodesList = new PlayerPromocodesListCtl_1.PlayerPromocodesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PlayerPromocodesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PlayerJackpotWinsList", {
        get: function () {
            if (!this._PlayerJackpotWinsList) {
                this._PlayerJackpotWinsList = new PlayerJackpotWinsListCtl_1.PlayerJackpotWinsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PlayerJackpotWinsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PlayerFavoriteGamesList", {
        get: function () {
            if (!this._PlayerFavoriteGamesList) {
                this._PlayerFavoriteGamesList = new PlayerFavoriteGamesListCtl_1.PlayerFavoriteGamesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PlayerFavoriteGamesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PlayerAuthLogList", {
        get: function () {
            if (!this._PlayerAuthLogList) {
                this._PlayerAuthLogList = new PlayerAuthLogsListCtl_1.PlayerAuthLogListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PlayerAuthLogList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PlayerMultiaccountsList", {
        //private static _PlayerMultiaccountsList : PlayerMultiaccountsListCtl;
        get: function () {
            if (!this._PlayerMultiaccountsList) {
                this._PlayerMultiaccountsList = new PlayerMultiaccountsListCtl_1.PlayerMultiaccountsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PlayerMultiaccountsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PlayerGameLogsList", {
        get: function () {
            if (!this._PlayerGameLogsList) {
                this._PlayerGameLogsList = new PlayerGameLogsListCtl_1.PlayerGameLogsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PlayerGameLogsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "DomainList", {
        get: function () {
            if (!this._DomainList) {
                this._DomainList = new DomainListCtl_1.DomainListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._DomainList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "FinanceDepositsList", {
        // public static get AppCoreRedirectList() : AppCoreRedirectListCtl {
        //      if(!this._AppCoreRedirectList) {
        //          this._AppCoreRedirectList = new AppCoreRedirectListCtl(DIALOG.DialogApiError); 
        //      }
        //      return this._AppCoreRedirectList;
        //  }
        get: function () {
            if (!this._FinanceDepositsList) {
                this._FinanceDepositsList = new FinanceDepositsListCtl_1.FinanceDepositsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._FinanceDepositsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "FinanceRevsharesList", {
        //private static _FinanceRevsharesList : FinanceRevsharesListCtl;
        get: function () {
            if (!this._FinanceRevsharesList) {
                this._FinanceRevsharesList = new FinanceRevsharesListCtl_1.FinanceRevsharesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._FinanceRevsharesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "FinanceWithdrawsList", {
        get: function () {
            if (!this._FinanceWithdrawsList) {
                this._FinanceWithdrawsList = new FinanceWithdrawsListCtl_1.FinanceWithdrawsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._FinanceWithdrawsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "FinanceWithdrawRequestsList", {
        get: function () {
            if (!this._FinanceWithdrawRequestsList) {
                this._FinanceWithdrawRequestsList = new FinanceWithdrawRequestsListCtl_1.FinanceWithdrawRequestsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._FinanceWithdrawRequestsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "UsersPermissions", {
        get: function () {
            if (!this._UsrPermissions) {
                this._UsrPermissions = new UsrPermissionsCtl_1.UsrPermissionsCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._UsrPermissions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "UsersPermissionsDocs", {
        get: function () {
            if (!this._UsrPermissionsDocs) {
                this._UsrPermissionsDocs = new UsrPermissionDocsCtl_1.UsrPermissionDocsCtl(coreDialog_1.DIALOG.DialogApiError, ADMIN.UIState);
            }
            return this._UsrPermissionsDocs;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BonusTemplatesList", {
        get: function () {
            if (!this._BonusTemplatesList) {
                this._BonusTemplatesList = new BonusTemplatesListCtl_1.BonusTemplatesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BonusTemplatesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "EventBindingBonusesList", {
        get: function () {
            if (!this._EventBindingBonusesList) {
                this._EventBindingBonusesList = new EventBindingBonusesListCtl_1.EventBindingBonusesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._EventBindingBonusesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "EventBindingDescriptionsList", {
        get: function () {
            if (!this._EventBindingDescriptionsListCtl) {
                this._EventBindingDescriptionsListCtl = new EventBindingDescriptionsListCtl_1.EventBindingDescriptionsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._EventBindingDescriptionsListCtl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "EventBindingOnDepositCfg", {
        get: function () {
            if (!this._EventBindingOnDepositCfg) {
                this._EventBindingOnDepositCfg = new EventBindingOnDepositCfgCtl_1.EventBindingOnDepositCfgCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._EventBindingOnDepositCfg;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "EventBindingOnLevelCfg", {
        get: function () {
            if (!this._EventBindingOnLevelCfg) {
                this._EventBindingOnLevelCfg = new EventBindingOnLevelCfgCtl_1.EventBindingOnLevelCfgCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._EventBindingOnLevelCfg;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "EventBindingOnLoginCfg", {
        get: function () {
            if (!this._EventBindingOnLoginCfg) {
                this._EventBindingOnLoginCfg = new EventBindingOnLoginCfgCtl_1.EventBindingOnLoginCfgCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._EventBindingOnLoginCfg;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "EventBindingOnTimerCfg", {
        get: function () {
            if (!this._EventBindingOnTimerCfg) {
                this._EventBindingOnTimerCfg = new EventBindingOnCashBackCfgCtl_1.EventBindingOnCashBackCfgCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._EventBindingOnTimerCfg;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BonusTemplateLocalesList", {
        get: function () {
            if (!this._BonusTemplateLocalesList) {
                this._BonusTemplateLocalesList = new BonusTemplateLocalesListCtl_1.BonusTemplateLocalesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BonusTemplateLocalesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BonusTemplatePlayerTagsList", {
        get: function () {
            if (!this._BonusTemplatePlayerTagsList) {
                this._BonusTemplatePlayerTagsList = new BonusTemplatePlayerTagsListCtl_1.BonusTemplatePlayerTagsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BonusTemplatePlayerTagsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "BonusTemplatesCurrencyConfigList", {
        get: function () {
            if (!this._BonusTemplatesCurrencyConfigList) {
                this._BonusTemplatesCurrencyConfigList = new BonusTemplateCurrencyConfigListCtl_1.BonusTemplatesCurrencyConfigListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BonusTemplatesCurrencyConfigList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PromoCodeTypesList", {
        get: function () {
            if (!this._PromoCodeTypesList) {
                this._PromoCodeTypesList = new PromoCodeTemplatesListCtl_1.PromoCodeTemplatesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PromoCodeTypesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PromoCodeTypeCodesList", {
        get: function () {
            if (!this._PromoCodeTypeCodesList) {
                this._PromoCodeTypeCodesList = new PromoCodeTemplateCodesListCtl_1.PromoCodeTemplateCodesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PromoCodeTypeCodesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PromoCodeTypeBonusesList", {
        get: function () {
            if (!this._PromoCodeTypeBonusesList) {
                this._PromoCodeTypeBonusesList = new PromoCodeTemplateBonusesListCtl_1.PromoCodeTemplateBonusesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PromoCodeTypeBonusesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PromoCodeTemplatesLocalesList", {
        get: function () {
            if (!this._PromoCodeTemplatesLocalesList) {
                this._PromoCodeTemplatesLocalesList = new PromoCodeTemplatesLocalesListCtl_1.PromoCodeTemplatesLocalesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PromoCodeTemplatesLocalesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PromoCodeTemplatesCountriesList", {
        get: function () {
            if (!this._PromoCodeTemplatesCountriesList) {
                this._PromoCodeTemplatesCountriesList = new PromoCodeTemplatesCountriesListCtl_1.PromoCodeTemplatesCountriesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PromoCodeTemplatesCountriesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PromoCodeTemplateAmountsList", {
        //private static _PromoCodeTemplateAmountsList : PromoCodeTemplateAmountsListCtl;
        get: function () {
            if (!this._PromoCodeTemplateAmountsList) {
                this._PromoCodeTemplateAmountsList = new PromoCodeTemplateAmountsListCtl_1.PromoCodeTemplateAmountsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PromoCodeTemplateAmountsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PromoCodeTypeCodesLogList", {
        get: function () {
            if (!this._PromoCodeTypeCodesLogList) {
                this._PromoCodeTypeCodesLogList = new PromoCodeTemplateCodesLogsListCtl_1.PromoCodeTemplateCodesLogListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PromoCodeTypeCodesLogList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PlayerLevelsList", {
        get: function () {
            if (!this._PlayerLevelsList) {
                this._PlayerLevelsList = new PlayersLevelsListCtl_1.PlayerLevelsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PlayerLevelsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PlayerLevelLocalesList", {
        get: function () {
            if (!this._PlayerLevelLocalesList) {
                this._PlayerLevelLocalesList = new PlayerLevelLocalesListCtl_1.PlayerLevelLocalesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PlayerLevelLocalesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PlayerLevelOffersList", {
        get: function () {
            if (!this._PlayerLevelOffersList) {
                this._PlayerLevelOffersList = new PlayerLevelOffersListCtl_1.PlayerLevelOffersListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PlayerLevelOffersList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PlayerLevelAttributesList", {
        get: function () {
            if (!this._PlayerLevelAttributesList) {
                this._PlayerLevelAttributesList = new PlayerLevelAttributesListCtl_1.PlayerLevelAttributesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PlayerLevelAttributesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "PlayerLevelBetAmountsList", {
        get: function () {
            if (!this._PlayerLevelBetAmountsList) {
                this._PlayerLevelBetAmountsList = new PlayerLevelBetAmountsListCtl_1.PlayerLevelBetAmountsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._PlayerLevelBetAmountsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "EventBindingsList", {
        get: function () {
            if (!this._EventBindingsList) {
                this._EventBindingsList = new EventBindingsListCtl_1.EventBindingsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._EventBindingsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "TopGamesList", {
        get: function () {
            if (!this._TopGamesList) {
                this._TopGamesList = new TopGamesListCtl_1.TopGamesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._TopGamesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "JackpotsList", {
        get: function () {
            if (!this._JackpotsList) {
                this._JackpotsList = new JackpotsListCtl_1.JackpotsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._JackpotsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "JackpotPlayerTagsList", {
        get: function () {
            if (!this._JackpotPlayerTagsList) {
                this._JackpotPlayerTagsList = new JackpotRestrictedPlayerTagsListCtl_1.JackpotRestrictedPlayerTagsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._JackpotPlayerTagsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "JackpotsLocalesList", {
        get: function () {
            if (!this._JackpotsLocalesList) {
                this._JackpotsLocalesList = new JackpotLocalesListCtl_1.JackpotLocalesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._JackpotsLocalesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "JackpotWinHistoryList", {
        get: function () {
            if (!this._JackpotWinHistoryList) {
                this._JackpotWinHistoryList = new JackpotWinHistoryListCtl_1.JackpotWinHistoryListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._JackpotWinHistoryList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "JackpotTransferHistoryList", {
        get: function () {
            if (!this._JackpotTransferHistoryList) {
                this._JackpotTransferHistoryList = new JackpotTransferHistoryListCtl_1.JackpotTransferHistoryListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._JackpotTransferHistoryList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "ReportTotalProfitList", {
        //private static _ReportTotalProfitList : ReportTotalProfitListCtl;
        get: function () {
            if (!this._ReportTotalProfitList) {
                this._ReportTotalProfitList = new RepTotalProfitCtl_1.ReportTotalProfitListCtl(coreDialog_1.DIALOG.DialogApiError, this.UIState);
            }
            return this._ReportTotalProfitList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "ReportPlayerProfitList", {
        //private static _ReportPlayerProfitList : ReportPlayerProfitListCtl;
        get: function () {
            if (!this._ReportPlayerProfitList) {
                this._ReportPlayerProfitList = new RepPlayerProfitCtl_1.ReportPlayerProfitListCtl(coreDialog_1.DIALOG.DialogApiError, this.UIState);
            }
            return this._ReportPlayerProfitList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "ReportBonusesList", {
        //private static _ReportBonusesList : ReportBonusesListCtl;
        get: function () {
            if (!this._ReportBonusesList) {
                this._ReportBonusesList = new RepBonusesCtl_1.ReportBonusesListCtl(coreDialog_1.DIALOG.DialogApiError, this.UIState);
            }
            return this._ReportBonusesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "ReportPromoCodeTplList", {
        // private static _ReportPromoCodeTplList: ReportPromoCodeTplListCtl;
        get: function () {
            if (!this._ReportPromoCodeTplList) {
                this._ReportPromoCodeTplList = new RepPromoCodesCtl_1.ReportPromoCodeTplListCtl(coreDialog_1.DIALOG.DialogApiError, this.UIState);
            }
            return this._ReportPromoCodeTplList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "ReportPaySystemsList", {
        get: function () {
            if (!this._ReportPaySystemsList) {
                this._ReportPaySystemsList = new RepPaySystemsCtl_1.ReportPaySystemsListCtl(coreDialog_1.DIALOG.DialogApiError, this.UIState);
            }
            return this._ReportPaySystemsList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ADMIN, "ReportWithdrawsList", {
        //private static _ReportWithdrawsList: ReportWithdrawsListCtl;
        get: function () {
            if (!this._ReportWithdrawsList) {
                this._ReportWithdrawsList = new RepWithdrawalsCtl_1.ReportWithdrawsListCtl(coreDialog_1.DIALOG.DialogApiError, this.UIState);
            }
            return this._ReportWithdrawsList;
        },
        enumerable: true,
        configurable: true
    });
    return ADMIN;
}());
exports.ADMIN = ADMIN;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/coreAdmin.ts
// module id = 216
// module chunks = 0